// 通用
export const C001 = '网络暂时无法使用，请稍候重试。';
export const C002 = '暂无数据';
export const C003 = '当前功能暂未开放';
export const C004 = 'TYPE 传输问题';
export const C005 = '请选择{0}张图片';
export const C006 = '大小请不超过{0}MB';
export const C007 = '开始上传 OSS';
export const C008 = '网络异常';
export const C009 = '当前网络状况不佳，请稍候重新尝试。';
export const C010 = '服务升级公告';
export const C011 = '为了给您提供更优质的服务，我们正在实施系统升级，期间本系统功能将不可使用。因此给您带来的不便，我们深表歉意，并将尽快恢复对您的服务。';
export const C012 = '图片上传失败';
export const C013 = '请输入正确的手机号';
export const C014 = '请输入正确的身份证号';
export const C015 = '是否确定退出登录';
export const C016 = '{0}成功';
export const C017 = '{0}失败';
export const C018 = '缺少必要参数[{0}]';
export const C019 = '请选择{0}';
export const C020 = '请检查开启设备蓝牙功能';
export const C021 = '是否确认清除缓存？';
export const C022 = '为了让您能及时接收通知，请打开服务通知';
export const C023 = '请在设置中开启录音权限';
export const C024 = '存在上传失败的{0}，请重新上传。';
export const C025 = '仅支持上传{0}';
export const C026 = '不支持上传扩展名为{0}的{1}';
export const C027 = '录音时间太短';
export const C028 = '您的访问过于频繁,请稍后再试。';
export const C029 = '温馨提示';
export const C030 = '该功能暂未开通';
export const C031 = '请输入{0}';
export const C032 = '此手机号还未注册，请先去注册';
export const C033 = '密码必须由8-16位的数字，字母或特殊字符中的任意两种组成。';
export const C034 = '两次输入的密码不同';
export const C035 = '请确认是否已完成{0}？';
export const C036 = '是否确定{0}？';

export const LOGIN001 = '撤回授权后，即会退出登录当前账号，是否确认撤回授权？';
export const LOGIN002 = '暂不支持关闭此消息通知';
export const LOGIN003 = '是否确认注销当前账号？';
export const LOGIN004 = '获取账号信息失败，请稍后重试';
export const LOGIN005 = '登录失败，请重新登录';
export const LOGIN006 = '此手机号已经注册，请直接登录';
export const LOGIN007 = '此手机号还未注册，请先去注册';

export const APPOINT001 = '今日挂号已结束！请选择预约挂号！';
export const APPOINT002 = '未查询到医生信息';
export const APPOINT003 = '此科室暂无排班信息';
export const APPOINT004 = '上午现场挂号已结束，下午现场挂号时间从{0}-{1}开始！';
export const APPOINT005 = '现场挂号时间从{0}-{1}开始！';
export const APPOINT006 = '发热儿童无需预约，请直接到门诊二部1楼儿科门诊就诊';
export const APPOINT007 = '今日挂号截止到{0}-{1}，是否选择{2}未来几日号源？';
export const APPOINT008 = '请选择{0}原因';
export const APPOINT009 = '取消{0}成功后，{1}';
export const APPOINT010 = '款项将原路退回到您的就诊卡中。';
export const APPOINT011 = '款项将在1-7个工作日内原路退回到您的账户。';
export const APPOINT012 = '取消{0}成功，{1}{2}将退回您的就诊卡内';
export const APPOINT013 = '数据加载中...';
export const APPOINT014 = '暂无号源';
export const APPOINT015 = '加载失败，请稍后重试';
export const APPOINT016 = '暂无院区数据';
export const APPOINT017 = '暂无医生数据';
export const APPOINT018 = '暂无排班数据';
export const APPOINT019 = '1周内若有发热（体温≥37℃）、干咳、乏力、咽痛等呼吸道症状，请不要预约专家号，请先到发热门诊就诊。';
export const APPOINT020 = '1周内若有发热（体温≥37℃）、干咳、乏力、咽痛等呼吸道症状，请不要预约专家号，请先到儿科发热门诊就诊（医院北门西侧）。';
export const APPOINT021 = '请到医院现场挂号，或选择其他医生';
export const APPOINT022 = '到达医院后才可以挂当日号';
export const APPOINT023 = '已停诊';
export const APPOINT024 = '已约满';
export const APPOINT025 = '1周内若有发热（体温≥37℃）、干咳、乏力、咽痛等呼吸道症状，请不要预约专家号，请先到发热门诊就诊（医院北门西侧）。';
export const APPOINT026 = '温馨提示：疫情期间请到各科室分诊处签到分诊。';
export const APPOINT027 = '挂号后不能退号，核对无误后如需继续，请点击确定，否则点击取消。';
export const APPOINT028 = '就诊日零点以后预约号不能退，如需继续请点击确定，否则点击取消。';
export const APPOINT029 = '{0}时间为每天{1}-{2}';
export const APPOINT030 = '实名制预约，该患者大于等于{0}周岁，预约{1}点击确定继续，点击取消预约其他科室或更换就诊人';
export const APPOINT031 = '请到院后通过公众号或自助机签到后排队就诊。（提示:如您错过预约时间，需先取消公众号内已预约记录后重新预约）';
export const APPOINT032 = '知名专家诊查费100元，就诊时请确保卡内充足余额';
export const APPOINT033 = '高危孕产妇，为了母婴安全，医院将为您提供高危专案管理，由我院安排经验丰富的主任医生为您服务。高危孕妇只能预约"高危1"，谢谢您的合作！';
export const APPOINT034 = '1. 请携带身份证、就诊卡在预约时间前30分钟到院签到取号，过期请重新挂号。2. 如需取消{0}，请在就诊日前一日操作';
export const APPOINT035 = '所有来院人员（包括患者和陪同人)请提前在手机上申请山东健康通行码，并带好患者和陪同人的有效身份证件，主动配合预检分诊。';
export const APPOINT036 = '温馨提示：医生在看诊时将收取心理咨询与治疗费用，建议您提前充值';
export const APPOINT037 = '是否立即支付当前挂号费用？';
export const APPOINT038 = '当日挂号时间{0}-{1}，请耐心等待';
export const APPOINT039 = '您已{0}成功，请立即支付{1}，如超时支付，系统将自动取消！';
export const APPOINT040 = '您是否确认删除当前选择的就诊记录？数据删除后将无法恢复，请您核实确认后再删除。';
export const APPOINT041 = '记录已超出30天，请前往医院窗口进行取消操作。';
export const APPOINT042 = '欢迎预约多学科综合门诊';
export const APPOINT043 = '为方便门诊疑难病患者诊疗，避免多科往返，我院开设多学科门诊，欢迎预约咨询。';
export const APPOINT044 = '本周暂无排班';
export const APPOINT045 = '请输入病情描述';
export const APPOINT046 = '请上传图片';
export const APPOINT047 = '您有上传失败的图片，请重新上传';
export const APPOINT048 = '未查询到就诊卡信息，请持有效证件到窗口办理登记';
export const APPOINT049 = '您当前选择的是医保卡：{0}，请核对身份证信息！以便顺利就诊。';
export const APPOINT050 = '您当前选择的是{0}，卡面编号为：{1}，请与手持的就诊卡进行核对！以便顺利就诊。';
export const APPOINT051 = '签到成功，请到诊室候诊，若以电子健康卡就诊，进入诊室时请提前打开电子健康卡。温馨提示：如需查看本签到页面，可在"门诊服务"的"预约签到"处打开。';
export const APPOINT052 = '未查到此就诊人信息，请重新绑定此就诊人';
export const APPOINT053 = '您的账户余额不足以支付本次诊查费，请充值后就诊。';
export const APPOINT054 = '为了您就诊方便快捷，诊疗安全准确，请详细填写预问诊信息，谢谢！';
export const APPOINT055 = '该预约记录为医保支付，请到线下窗口退费';
export const APPOINT056 = '医保卡支付挂号费，暂不支持取消预约，请确认后继续缴费';
export const APPOINT057 = '缺少必要参数[{0}]，请重新发起支付';
export const APPOINT058 = '暂无科室数据';
export const APPOINT059 = '暂时无法关注';
export const APPOINT060 = '无法取消关注';
export const APPOINT061 = '当前选择的就诊人信息并非本人信息';
export const APPOINT062 = '未获取到当前位置信息';
export const APPOINT063 = '获取位置信息失败，请前往设置中检查是否开启获取位置信息权限';
export const APPOINT064 = '预约挂号后，请及时充值（最少不低于30元）';
export const APPOINT065 = '请就诊完毕在自助机打印门诊病历，急诊留观患者出院前在医生处打印。';
export const APPOINT066 = '尊敬的患者朋友：<br>1.为保证医疗资源合理利用,减少您等待时间,请务必提前一刻钟内到分诊台报到,根据叫号提醒及时就诊,过号一律作废<br>2.如不能按时就诊可在预约时间两小时前进行取消,就诊执行一医一患一诊室<br>3.知名专家诊查费100元';
export const APPOINT067 = '<div style="text-indent: 2em;">健康码黄码、红码及有发热、咳嗽、咽痛等呼吸道症状者请到发热门诊就诊</div><div class="sn-ta-right">龙口市人民医院</div>';
export const APPOINT068 = '此操作需支付挂号费{0}元，是否继续？';
export const APPOINT069 = '为确保诊疗效率，请就诊患者携带好病例、影像学资料、化验检查结果、诊疗记录等相关病史资料来院就诊。';
export const APPOINT070 = '暂未获取到您的卡余额，请稍候重试。';
export const APPOINT071 = '您就诊卡预交金额不足，请充值';
export const APPOINT072 = '此科室为儿科，仅允许14岁以下儿童预约';
export const APPOINT073 = '，请于就诊前30分钟公众号预约签到或自助机到诊确认签到';
export const APPOINT074 = '您有上传失败的文件，请重新上传';
export const APPOINT075 = '请上传患处资料';
export const APPOINT076 = '请上传检查检验报告';
export const APPOINT077 = '您有上传失败的视频，请重新上传';
export const APPOINT078 = '支付宝小程序中暂不支持上传文件';
export const APPOINT079 = '医院信息系统升级期间，无法在手机端办理当日挂号。';
export const APPOINT080 = '是否确认取消候补？';
export const APPOINT081 = '请确认预约<br><span class="sn-fc-red21">{0}</span>{1}<br>预约候诊时间<br>{2}';
export const APPOINT082 = '为给您提供更好的诊疗服务，请您在就诊前认真填写预问诊信息';
export const APPOINT083 = '王荣的专家号，在门诊的前一天，即周一中午12:00开放预约，请知悉';
export const APPOINT084 = '到医院后请先到导诊台或自助机报道';
export const APPOINT085 = '当前科室暂不支持当日挂号';
export const APPOINT086 = '请您至我院相应专家门诊或外科普通门诊开立CT检查申请单（胸部薄层平扫+刻光盘）并预约检查，资料备齐后再行预约会诊。咨询电话：0531-68778272。';
export const APPOINT087 = '请于会诊前资料备齐后再行预约会诊。';
export const APPOINT088 = '请选择胸部薄层CT是否刻录光盘';
export const APPOINT089 = '请选择是否准备历次影像片子或者DICOM格式胸部薄层CT光盘';
export const APPOINT090 = '到达医院后才可以进行签到';
export const APPOINT091 = '当日手机挂号费默认为：自费';
export const APPOINT092 = '挂号成功后请至少提前15分钟到分诊台报到等候就诊';
export const APPOINT093 = '多学科综合门诊收费执行鲁价格二发【2018】144、鲁价格二发【2018】145、鲁医保【2023】35号文件规定，≤3位专家500元，每增加一位专家加收100元。';
export const APPOINT094 = '仅限{0}周岁以上患者预约';
export const APPOINT095 = '请先保存问诊表';
export const APPOINT096 = '亲爱的家长朋友，如果您的孩子有头痛（头晕/扁桃体肥大腺样体肥大、睡眠打鼾/过敏性鼻炎）症状，请填写该表格，该表格可以帮助医生详细的评估患儿病情，利于医生做出正确的诊断。';
export const APPOINT097 = '同一身份证号码，预约同一医生，预约成功后1天最多取消预约3次，触发进入黑名单1天；每位患者14天内最多取消5次，触发将进入黑名单30天，进入黑名单后无法预约就诊。是否要取消本次预约？';
export const APPOINT098 = '请在当日预约时间之前30分钟内，到医院自助机或人工挂号窗口现场取号';
export const APPOINT099 = '您符合70岁以上老人减免普通挂号费的政策，本次挂号费已进行减免';
export const APPOINT100 = '您尚未签约惠民信用就医支付，如需使用请去诊疗服务->门诊服务下惠民信用就医功能进行签约';
export const APPOINT101 = '您的惠民信用就医支付额度不足，请使用其他方式进行支付。';
export const APPOINT102 = '有专家两院区看诊，请选择您看诊院区';
export const APPOINT103 = '请进行身份绑定后再查询';
export const APPOINT104 = '预约时间前两小时之内才可以签到';
export const APPOINT105 = '今日号源预约已满，若您仍希望就诊，请前往分诊台咨询。号源紧张，敬请谅解。';
export const APPOINT106 = '请您提前15分钟到达相应诊区报到取号，等候就诊。注意：若您不能如约前来就诊，可线上退号。';
export const APPOINT107 = '医生已下线';
export const APPOINT108 = '医生今日咨询人数已满';
export const APPOINT109 = '暂时不支持未建档患者预约，是否前往进行建档？';
export const APPOINT110 = '请耐心等待医护人员审核，审核结果会以短信和微信订阅消息的形式发送至您的手机，请注意查收。';
export const APPOINT111 = '<span class="sn-fc-red21 sn-fw-bold">如果您为家人预约，请务必使用就诊人本人身份证号预约，否则就诊时无法就诊。</span>';
export const APPOINT112 = '预约挂号后，请及时充值，最少不低于30元（多学科综合门诊除外，多学科综合门诊诊察费需要根据参与会诊专家数量进行确定。）';
export const APPOINT113 = '已提交，等待候补中...';
export const APPOINT114 = '敬告，非以上情况，请勿挂此号。';
export const APPOINT115 = '我院手机医保移动支付已全面升级，<span class="sn-fc-red21 sn-fw-bold red21Color-content boldFont-content">济宁市职工医保</span>患者本人使用我院微信公众号预约挂号时可首选<span class="sn-fc-red21 sn-fw-bold red21Color-content boldFont-content">[医保支付]</span>，使用医保个人账户内余额和职工门诊统筹支付诊查费！使用过程中如有问题，可咨询医院工作人员。';
export const APPOINT116 = '目前仅支持济宁市市医保参保人使用本人的医保账户进行支付。';
export const APPOINT117 = '<span class="sn-fc-red21">自2024年9月2日起，开放号源时间由早上7点改为晚上8点（例如: 本周周一晚20:00开放下周二的号源）</span>';
export const APPOINT118 = '<span class="sn-fc-red21 sn-fs-32">痤疮门诊只接诊痤疮患者，痤疮患者请点击确认，否则点击取消。</span>';
export const APPOINT119 = '本次就诊的挂号费及后续产生的费用均为自费，不能参加医保统筹报销，您确定自费签到操作嘛？';
export const APPOINT120 = '为提高您的就诊效率，建议就诊卡内至少充值50元';
export const APPOINT121 = '当前支付方式为{0}，请您先前往医保小程序进行身份授权';
export const APPOINT122 = '请您确认是否已完成医保支付？';
export const APPOINT123 = '在线报到时间已过，请到就诊科室护士站报到。';
export const APPOINT124 = '您尚未完成报到，请在就诊前及时报到';
export const APPOINT125 = '暂未查询到您的医保支付状态，请稍后重试。 ';
export const APPOINT126 = '暂未查询到您的结算信息，请稍后重试。 ';
export const APPOINT127 = '尊敬的患者，由于医保平台正在升级，暂不支持异地身份的医保患者线上结算。您可前往分诊台进行医保挂号或在线自费挂号。';
export const APPOINT128 = '尊敬的患者，由于医保平台正在升级，暂不支持异地身份的医保患者线上结算。您可前往自助机或分诊台进行医保报到，也可在线自费报到。';
export const APPOINT129 = '请前往检验科人工窗口签到取号。';
export const APPOINT130 = '暂无科室简介';

export const RECHARGE001 = '预交金余额不足，请充值';
export const RECHARGE002 = '储存支付参数失败';
export const RECHARGE003 = '获取支付参数失败';
export const RECHARGE004 = '预交金余额不足，是否立即充值？';
export const RECHARGE005 = '卡余额不足，请选择是否充值';
export const RECHARGE006 = '最多充值{0}元！';
export const RECHARGE007 = '最少充值{0}元！';
export const RECHARGE008 = '请输入正确的充值金额';
export const RECHARGE009 = '充值金额不足';
export const RECHARGE010 = '没有获取门诊卡余额信息！';
export const RECHARGE011 = '请解绑后重新添加就诊人';
export const RECHARGE012 = '该就诊人暂未绑定门诊卡，是否前去绑卡？';
export const RECHARGE013 = '暂未查询到您的住院信息，请核实后再次操作~';
export const RECHARGE014 = '您输入的姓名与该“住院号对应姓名”不一致，请重试或联系医院住院处确认。';
export const RECHARGE015 = '病人不是在院状态，请到窗口交费';
export const RECHARGE016 = '未查询到此就诊人的住院信息';
export const RECHARGE017 = '自2021年09月07起，使用自助设备及在线缴纳预交金，不再提供纸质凭单，出院结算时无须交回。如需纸质预交金收据，请至人工窗口缴纳。人工窗口打印的预交金收据，出院时需全部交回。是否继续：';
export const RECHARGE018 = '贫困救助人员享受住院免押金政策，您不需要缴纳住院押金。';
export const RECHARGE019 = '没有获取住院号余额信息!';
export const RECHARGE020 = '精准扶贫患者无须缴纳押金';
export const RECHARGE021 = '充值时间为每天{0}-{1}。';
export const RECHARGE022 = '请确认充值信息';
export const RECHARGE023 = '请不要为他人代交，以免影响退费';
export const RECHARGE024 = '您的住院信息已失效，是否重新选择住院信息进行住院充值？';

export const PATIENT001 = '使用前请先添加一名就诊人';
export const PATIENT002 = '正在领取电子健康卡...';
export const PATIENT003 = '领取电子健康卡成功！';
export const PATIENT004 = '此就诊人未建档';
export const PATIENT005 = '获取就诊人建档资料失败，请稍候重试';
export const PATIENT006 = '您的身份证不合法，请前往进行实名认证！';
export const PATIENT007 = '默认就诊人切换成功！';
export const PATIENT008 = '添加就诊人成功！';
export const PATIENT009 = '解绑成功！';
export const PATIENT010 = '修改成功！';
export const PATIENT011 = '删除就诊人成功！';
export const PATIENT012 = '无法识别身份证';
export const PATIENT013 = '身份证识别成功';
export const PATIENT014 = '就诊人信息不完善，请删除重新建档！';
export const PATIENT015 = '身份证非本人身份证，请完善个人身份信息！';
export const PATIENT016 = '请先选择就诊人';
export const PATIENT017 = '请先选择就诊卡';
export const PATIENT018 = '暂时不支持未建档患者预约，请尝试前往个人中心-就诊人管理-在线建档或线下窗口建档后重试！';
export const PATIENT019 = '请扫描条形码';
export const PATIENT020 = '请输入正确的监护人身份证';
export const PATIENT021 = '您有未填内容！';
export const PATIENT022 = '您已注册过该身份证！';
export const PATIENT023 = '动态码短信已发送至{0}';
export const PATIENT024 = '请先完善就诊人信息';
export const PATIENT025 = '{0}岁以下儿童暂不支持在线建档，请到窗口办理就诊卡，谢谢合作！';
export const PATIENT026 = '就诊卡未填写手机号,请到收费窗口进行补全';
export const PATIENT027 = '您在院档案信息不完整，请联系院方补全信息后方可继续操作！';
export const PATIENT028 = '删除该就诊人？';
export const PATIENT029 = '删除选中的就诊人？';
export const PATIENT030 = '请选择要删除的就诊人';
export const PATIENT031 = '未检出到您在医院办理过健康卡，请到窗口办理就诊卡，谢谢合作！';
export const PATIENT032 = '未检测到{0}人在医院办理过{1}';
export const PATIENT033 = '就诊人信息与上传身份证信息不匹配，请检查身份证或就诊人信息。';
export const PATIENT034 = '请完善{0}';
export const PATIENT035 = '当前添加就诊人未成年人，需继续完善陪诊家长信息方可成功建档';
export const PATIENT036 = '未检测到您在医院办理过健康卡，是否进行在线建档！';
export const PATIENT037 = '当前就诊人不支持领取电子健康卡';
export const PATIENT038 = '暂时无法修改地址，如需修改，请前往医院窗口进行修改！';
export const PATIENT039 = '该卡为专用卡，不支持此功能';
export const PATIENT040 = '请输入{0}';
export const PATIENT041 = '同一登录手机号码，7天内最多可解绑就诊人10次，触发将进入黑名单14天，进入黑名单后无法预约就诊。是否要删除就诊人？';
export const PATIENT042 = '该就诊人暂未身份绑定，请先前去绑定';
export const PATIENT043 = '该就诊人暂未身份绑定，是否前去绑定？';
export const PATIENT044 = '您在院内已建档，请您进行身份绑定';
export const PATIENT045 = '您的联系方式有误，请到窗口咨询办理更改手机号码。';
export const PATIENT046 = '为保护个人隐私，请选择以下方式验证。';
export const PATIENT047 = '如果您的联系方式为座机号、或手机号格式不正确等原因导致无法获取动态码时，请持身份证到医院门诊窗口更正后再进行认证。';
export const PATIENT048 = '提示：绑定建档信息后才能可以使用充值缴费、查询报告等更多功能，初次就诊用户请先完成建档后绑定。';
export const PATIENT049 = '未绑定门诊建档信息';
export const PATIENT050 = '未关联建档信息';
export const PATIENT051 = '就诊人数量超限，请删除不常用就诊人。';
export const PATIENT052 = '如果已建档仍提示未检测到就诊卡，请到医院窗口核实建档信息是否正确！';
export const PATIENT053 = '暂不支持在线建档，请去窗口办理就诊卡，谢谢合作！';
export const PATIENT054 = '未查询到住院患者信息';
export const PATIENT055 = '请先进行{0}再进行领取电子健康卡操作!';
export const PATIENT056 = '未检测到{0}在医院办理过{1}';
export const PATIENT057 = '您在医院预留的手机号有误，<span class="sn-fc-main sn-fs-32">请及时修改手机号。</span>';
export const PATIENT058 = '未查询到{0}';
export const PATIENT059 = '缺少必要参数[{0}]，请重新选择建档方式';
export const PATIENT060 = '当前建档方式为{0}，请您先前往医保小程序进行身份授权';
export const PATIENT061 = '您有必填项未填写或者未选择，请检查！';
export const PATIENT062 = '为保护个人隐私，请选择以下任一方式通过身份验证。';
export const PATIENT063 = '为保护个人隐私，请选择以下任何一种方式验证是否本人操作。';

export const SEARCH001 = '请填写{0}';
export const SEARCH002 = '未绑定{0}，是否前去绑定';
export const SEARCH003 = '开始时间不得大于截止时间';
export const SEARCH004 = '未查到近{0}的{1}记录';
export const SEARCH005 = '以上为近{0}的{1}记录';
export const SEARCH006 = '仅限查询{0}的记录';
export const SEARCH007 = '身份证校验不通过，请核实后输入';
export const SEARCH008 = '使用前请先绑定一张{0}';
export const SEARCH009 = '请输入正确的{0}';
export const SEARCH010 = '信息输入有误或未查询到{0}记录';
export const SEARCH011 = '请选择{0}';
export const SEARCH012 = '请绑定{0}后再进行查询';
export const SEARCH013 = '没有找到默认区间{0}至{1}的相关记录，请重新选择时间进行查询';
export const SEARCH014 = '未查到{0}至{1}的相关记录，请调整时段重新查询';
export const SEARCH015 = '正在查询，请稍等...';
export const SEARCH016 = '没有找到相关记录';
export const SEARCH017 = '{0}绑定期限已过期，是否重新绑定？';
export const SEARCH018 = '{0}需重新绑定';
export const SEARCH019 = '未绑定';
export const SEARCH020 = '未检测到{0}在医院办理过住院';
export const SEARCH021 = '住院费用查询功能只支持在院患者使用';
export const SEARCH022 = '住院费用查询功能仅支持在院患者，出院患者请携带有效证件到医院收款处查询';
export const SEARCH023 = '为确保您的正常就医流程，请您完善下您的地址';
export const SEARCH024 = '请选择查询日期';
export const SEARCH025 = '请选择出生日期';
export const SEARCH026 = '请输入正确的{0}卡号';
export const SEARCH027 = '如需下载PDF报告，请点击预览文件右上角转发分享按钮保存到手机本地，IOS系统只支持转发收藏。';
export const SEARCH028 = '如需下载PDF报告，请点击预览文件右上角转发分享按钮保存到手机本地，IOS系统只支持转发收藏。';
export const SEARCH029 = '在网络系统故障或其他特殊情况下，报告下载功能将不可用，请到医院获取纸质报告。';
export const SEARCH030 = '仅支持查询出院患者的费用记录';
export const SEARCH031 = '门诊病历由患者妥善保存，此内容为患者门诊诊疗电子记录，以患者保存的医师签字版为准。';
export const SEARCH032 = '线上检验结果查阅时间比医院出结果时间会有延迟，着急取报告的患者，请您自行到医院打印纸质报告，给您带来的不便，敬请谅解。';
export const SEARCH033 = '温馨提示: 因结算节点原因,具体费用以出院明细为准。';
export const SEARCH034 = '目前仅支持两腺超声改约！';
export const SEARCH035 = '请先选择检查日期，点击确定后选择检查时间。';
export const SEARCH036 = '该号源时段为超声专家检查时段，预约成功后，请于检查当日规定时间内至门诊三楼中区超声科分诊台补办费用等相关手续。';
export const SEARCH037 = '您预约的超声检查已成功改约至{0}{1}，请务必携带超声检查申请单，提前10分钟前往门诊三楼中区超声科分诊台签到取号。';
export const SEARCH038 = '该日暂无可预约时间段!';
export const SEARCH039 = '提交失败，请重新选择可预约时间！';
export const SEARCH040 = '已取消改约!';
export const SEARCH041 = '超声改约前需先到我院中心院区临床科室开具检查申请单，没有检查申请单无法改约！';
export const SEARCH042 = '请按缴费日期查询';
export const SEARCH043 = '提示：无法查询当天就诊的电子病历';
export const SEARCH044 = '线上报告查询受网络、设备、信息延时等因素影响，只作为参考使用，报告内容以医院相关部门发布的纸质报告为准。';
export const SEARCH045 = '为提高广大患者的就诊体验，我院计划于10月13日进行系统升级，10月13日前未缴费、未预约的超声检查申请单将全部作废！10月15日（下周日）有线上改约需求的患者，请10月13号后到医院相应科室重新挂号开具新的申请单才能进行改约操作。今天（10月8日）预约上10月13日-15日超声检查的，请务必于10月12日17:00前完成缴费；预约上10月9日-12日超声检查的，按照原流程完成检查即可，不受影响！给您带来的不便，敬请谅解！';
export const SEARCH046 = '线上检验结果查阅时间比医院出结果时间会有延迟，着急取报告的患者，请您自行到医院打印纸质报告；<span style="font-weight: bold;">影像检查报告及图像，请使用云影像功能查看，</span>给您带来的不便，敬请谅解。';
export const SEARCH047 = '如不能查询到检查检验结果，请尝试重新绑定就诊卡。';
export const SEARCH048 = '<div class="sn-fc-red21 sn-fw-bold">支持查询本功能上线之后的胃镜报告</div><div class="sn-fc-red21 sn-fw-bold">上线时间2023年11月1日</div>';
export const SEARCH049 = '仅限消化内镜部分住院小标本病理报告查询';

export const REFUND001 = '{0}会在三个工作日内返回到您的原充值账户';
export const REFUND002 = '由于网络原因，您的{0}申请失败请稍后再试';
export const REFUND003 = '继续{0}';
export const REFUND004 = '{0}会原路退回至充值账户，请确定是否{1}？';
export const REFUND005 = '当前这笔无法申请退款';
export const REFUND006 = '<div style="text-indent: 2em;">尊敬的病陪人朋友，我院于2023年10月13日、14日启用了新的门急诊信息系统，线上退款注意事宜如下：</div>1、10月14日零点后在线上或自助机充值的账户余额可申请线上退款；<br>2、10月14日零点前的账户余额可继续在门诊使用，暂不支持线上退款，如需退款请持原就诊卡到医院收费窗口办理退款！<br>感谢您的理解和配合！给您带来的不便，敬请谅解！';
export const REFUND007 = '线上充值3个月内可申请线上退款，若超过3个月请到窗口办理退款。';

export const CASEMAIL001 = '您有未上传的图片';
export const CASEMAIL002 = '因病历归档需要时间，请您在出院一周后进行病案邮寄的申请，谢谢配合！';
export const CASEMAIL003 = '请选择我已阅读并同意《知情同意书》';
export const CASEMAIL004 = '支付后将无法取消，是否确认支付？';
export const CASEMAIL005 = '您可以通过个人中心--病历邮寄申请记录--查看审核状态及快递物流信息';
export const CASEMAIL006 = '很抱歉，未获取到您的病案类型信息，您的病案可能尚未归档~';
export const CASEMAIL007 = '由于病历归档需要时间，请您于{0}天后进行病历邮寄申请，谢谢配合。';

export const NUCLEICACID001 = '还有未填或者未选择的内容';
export const NUCLEICACID002 = '请绑定{0}';
export const NUCLEICACID003 = '获取卡余额失败，请稍后再试。';
export const NUCLEICACID004 = '下载PDF报告失败，由于PDF报告发布有延迟，您的报告单可能暂未生成，请稍后再试，感谢您的配合！';
export const NUCLEICACID005 = '您需要"单人单管"进行采样、检测!';
export const NUCLEICACID006 = '核酸检测预约成功；到检测点后请您出示健康码和电子条形码进行核酸检测，无需打印纸质条码!';
export const NUCLEICACID007 = '上班时间上午{0}下午{1}';
export const NUCLEICACID008 = '如需查询核酸报告，请点击"就医服务"—"门诊报告"查看。';
export const NUCLEICACID009 = '本页面只展示移动端申请记录，如需查询核酸结果请到报告查询功能中进行查看。 点击查看';
export const NUCLEICACID010 = '当前页面只展示移动端核酸检测申请记录，如需查询核酸报告，请前往报告查询中查询。';

export const PAYMENT001 = '就诊科室不能使用医保支付';
export const PAYMENT002 = '您的类型不支持用医保结算此医嘱堆，请去窗口修改病人身份信息或者选择自费结算';

export const HOSPITALIZED001 = '未查询到该患者住院信息';
export const HOSPITALIZED002 = '入院登记已成功';
export const HOSPITALIZED003 = '请输入家庭电话';
export const HOSPITALIZED004 = '请输入联系人电话';
export const HOSPITALIZED005 = '请选择病人身份';
export const HOSPITALIZED006 = '请选择收款账户';
export const HOSPITALIZED007 = '患者未到医院，暂不能办理一键入院';

export const QUERY001 = '您是否已在门诊开立检查申请单？';
export const QUERY002 = '暂未获取到可改约排班';
